import type { CreateSocietyInput, UpdateSocietyInput } from '@idc-forms/schemas'
import { axiosPrivate } from '@/shared/api/axios'
import { buildListQueryString } from '@/shared/api/build-list-query-string'
import { API } from '@/shared/constants/api'
import type {
  PaginatedSocieties,
  SocietiesAdminParams,
  SocietyAdminRow
} from '../models/society-admin'

export async function getSocietiesAdmin(params: SocietiesAdminParams): Promise<PaginatedSocieties> {
  const qs = buildListQueryString(params)
  const { data } = await axiosPrivate.get<PaginatedSocieties>(
    `${API.societies.root}${qs ? `?${qs}` : ''}`
  )
  return data
}

/**
 * Los payloads son los MISMOS schemas Zod que valida el backend. Las
 * credenciales SAP vuelven ENMASCARADAS en la respuesta (nunca en claro).
 */
export async function createSociety(payload: CreateSocietyInput): Promise<SocietyAdminRow> {
  const { data } = await axiosPrivate.post<SocietyAdminRow>(API.societies.root, payload)
  return data
}

export async function updateSociety(
  id: string,
  payload: UpdateSocietyInput
): Promise<SocietyAdminRow> {
  const { data } = await axiosPrivate.patch<SocietyAdminRow>(API.societies.byId(id), payload)
  return data
}

export async function deleteSociety(id: string) {
  const { data } = await axiosPrivate.delete(API.societies.byId(id))
  return data
}
